import { render } from "./tzRaffleModal.vue?vue&type=template&id=2a36c540&scoped=true"
import script from "./tzRaffleModal.vue?vue&type=script&lang=js"
export * from "./tzRaffleModal.vue?vue&type=script&lang=js"

import "./tzRaffleModal.vue?vue&type=style&index=0&id=2a36c540&scoped=true&lang=css"

import exportComponent from "/Users/opeculiar/Downloads/www/tzraffles/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a36c540"]])

export default __exports__